export const RX_OPTED_IN_TITLE = "Add cooking requests";
export const RX_OPTED_OUT_TITLE = "This Restaurant doesn't accept cooking requests";
export const DEFAULT_RX_NOTE = "Requests cannot be assured and refunds for non-compliance will not be possible.";
export const RX_HALF_CARD_CTA = {
    ADD_REQUEST: "Add request",
    UPDATE: "Update request",
    REMOVE: "Remove",
};
export const RX_INSTRUCTION_CHAR_LIMIT = 100;

export const RX_HALF_CARD = {
    PLACEHOLDER: "Add cooking requests",
    INSTRUCTION:
        "Restaurant will try their best to fulfil your requests, but refund requests in this regard will not be possible.",
};

export const RX_INSTRUCTIONS_ASSETS = {
    TOAST_TICK: "4_0_Assets/Delivery_Instructions/ToastTick",
    TOAST_DELETE: "4_0_Assets/Delivery_Instructions/ToastDelete",
};

export const TOAST_MESSAGES = {
    ADD: "Your cooking request was added",
    UPDATE: "Updated cooking request",
    REMOVE: "Removed cooking request",
};

export const EMOJI_REGEX = /(?:\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu;

export const CHAR_LIMIT_ERROR_MESSAGE = "Max 100 characters allowed";
